import React, { ReactElement } from 'react'
import { Box } from 'theme-ui'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { PaymentMethod, startTransaction } from 'store/billing'

export type PaymentRequestData = {
  email: string
  password: string
  priceId: string
}

// for apple, google, browser pay
export default function XPay({ paymentMethod }: { paymentMethod: PaymentMethod }): ReactElement {
  const isApplePay = paymentMethod === PaymentMethod.APPLE
  const dispatch = useAppDispatch()
  const paymentRequest = useAppSelector(s => s.payments.paymentRequest)
  const sessionToken = useAppSelector(s => s.persistData.sessionToken)

  return (
    <Box>
      {paymentRequest && (
        <PaymentRequestButtonElement
          options={{
            paymentRequest,
            style: { paymentRequestButton: { type: 'buy', theme: 'light', height: '50px' } },
          }}
          onClick={async (event): Promise<void> => {
            event.preventDefault()
            // apple pay popup should be shown and can't wait for response
            isApplePay && paymentRequest?.show()
            dispatch(startTransaction())

            if (sessionToken) {
              // google/browser pay popup should be shown when registration is successful
              !isApplePay && paymentRequest?.show()
            }
          }}
        />
      )}
    </Box>
  )
}
